import converter from "../../../libs/number-to-words";
import common from "../../common";
import QuestionModuleStats from "../../maths/modules/QuestionModuleStats";
import QuestionModel from "../../maths/QuestionModel";
import QuestionValueGraphLabel from "../../maths/QuestionValueGraphLabel";
import QuestionView from "./QuestionView";

export default class QuestionViewGraphVen extends QuestionView {
    constructor(question) {
        super(question);

        this._graph = new PIXI.Container();
        this._graph.position.set(0, 280);
        this.addChild(this._graph);

        this._key = new PIXI.Container();
        this._key.position.set(130, 250);
        this.addChild(this._key);

        this._confirmButton.x = this._footer.x + 400;
        this._generated = [];

        this.createGraph();
    }

    getHeaderText() {

        const data = P3.assets.json("templates");
        const name = data.template ? data.template : this._question.module;
        let templates = data["templates"][name][this._question.type];

        if (templates) {
            templates = templates.slice().filter(x => this.filterTemplate(x));
        }

        if (!templates || !templates.length) {
            console.error("ERROR: NO TEMPLATE FOUND");
            return "ERROR: NO TEMPLATE FOUND";
        }

        this._template = P3.utils.selectRandom(templates);
        const words = data["words"];

        let text = this._template ? this._template.text : "";

        this._graphLabelCopies = [];
        let itemLabels = words.graph_labels[this._template.graph_label || 0]; //P3.utils.selectRandom(words.graph_labels).slice();

        const labelObj = {};

        let answerLabelA = null;
        let answerLabelB = null;
        let answerLabelC = null;

        //draw a random label for each value
        for (let i = 0; i < this._question.values.length; i++) {
            const itemIndex = P3.math.randomInt(0, itemLabels.length - 1);
            const itemLabel = itemLabels[itemIndex];
            this._graphLabelCopies.push(itemLabel);

            if (i === this._question.answerIndex) {
                this._question.answer.label = itemLabel;//fill answer label if we are asked to find a label
                if (this._question.templateType === QuestionModuleStats.TYPE_LOW ||
                    this._question.templateType === QuestionModuleStats.TYPE_HIGH ||
                    this._question.templateType === QuestionModuleStats.TYPE_EXACT) {
                    //console.log("ADDING ANSWER TO OPTIONS : " + itemLabel);
                    this._question.options.push(new QuestionValueGraphLabel(0, itemLabel));
                }
            }
            else if (i === this._question.labelIndexA) {
                answerLabelA = itemLabel;
            }
            else if (i === this._question.labelIndexB) {
                answerLabelB = itemLabel;
            }
            else if (i === this._question.labelIndexC) {
                answerLabelC = itemLabel;
            }
            else {
                labelObj["[ITEM" + i + "]"] = itemLabel;//build obj for easy swapping using regex
            }
            if ((this._question.templateType === QuestionModuleStats.TYPE_LOW ||
                this._question.templateType === QuestionModuleStats.TYPE_HIGH ||
                this._question.templateType === QuestionModuleStats.TYPE_EXACT)

                && this._question.options.length < 5 && i !== this._question.answerIndex) {
                this._question.options.push(new QuestionValueGraphLabel(0, itemLabel));
            }

            itemLabels.splice(itemIndex, 1);
        }

        P3.utils.shuffleArray(this._question.options);

        if (text) {

            const names = this.generateWords(this._template.text, words.names, /\[NAME([0-9])?]/g);
            for (const i in names) {
                if (names.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), names[i]);
                }
            }

            const enemies = this.generateWords(this._template.text, words.enemies, /\[ENEMY([0-9])?]/g);
            for (const i in enemies) {
                if (enemies.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), enemies[i]);
                }
            }

            const items = this.generateWords(this._template.text, words.items, /\[ITEM_([A-Za-z])?]/g);
            for (const i in items) {
                if (items.hasOwnProperty(i)) {
                    if (i === "[ITEM_A]" && answerLabelA) {
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), answerLabelA);
                    }
                    else if (i === "[ITEM_B]" && answerLabelB) {
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), answerLabelB);
                    }
                    else if (i === "[ITEM_C]" && answerLabelC) {
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), answerLabelC);
                    }
                    else {
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), labelObj[i]);
                    }
                }
            }

            const values = this.generateValues(this._template.text, /\[VALUE]/g);
            for (const i in values) {
                if (values.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), this._question.answer.value);
                }
            }
        }

        return text;
    }

    createGraph() {
        this._question.values.length < 4 ? this.createVenDouble() : this.createVenTriple();
    }

    /**
     * ven diagram with two sets
     */
    createVenDouble() {
        this._graph.image = new PIXI.mesh.NineSlicePlane(P3.assets.texture("answer_box_9slice"), 44, 88, 44, 88);
        this._graph.image.position.set(0, 60);
        this._graph.image.width = 420;
        this._graph.image.height = 310;
        this._graph.image.pivot.set(this._graph.image.width * 0.5, this._graph.image.height * 0.5);
        this._graph.addChild(this._graph.image);

        const circleTexture = P3.assets.texture("shape_2d_circle_1");

        const circleA = new PIXI.Sprite(circleTexture);
        circleA.anchor.set(0.5);
        const circleB = new PIXI.Sprite(circleTexture);
        circleB.anchor.set(0.5);

        circleA.x = -40;
        circleA.y = 80;

        circleB.x = 40;
        circleB.y = 80;

        this._graph.addChild(circleA, circleB);

        const offsetX = 50;
        const colors = [0xFF0000, 0x0000FF, 0x2E2B5F, 0x640CAD];

        //add in values
        const totalA = this._question.values[0];
        const labelA = new PIXI.Text(totalA, {fontSize: 42, fontFamily: "BBC Reith Sans", fontWeight: "bold", fill: colors[0]});
        labelA.x = circleA.x - offsetX;
        labelA.y = circleA.y;
        labelA.anchor.set(0.5);
        this._graph.addChild(labelA);

        const titleLabelA = new PIXI.Text(this._graphLabelCopies[0].toUpperCase(), {
            fontSize: 24,
            fontFamily: "BBC Reith Sans",
            fontWeight: "bold",
            fill: colors[0]
        });
        titleLabelA.anchor.set(0.5);
        titleLabelA.x = circleA.x - offsetX * 1.25;
        titleLabelA.y = circleA.y - circleA.height * 0.5 - 20;
        this._graph.addChild(titleLabelA);

        const totalB = this._question.values[1];
        const labelB = new PIXI.Text(totalB, {fontSize: 42, fontFamily: "BBC Reith Sans", fontWeight: "bold", fill: colors[1]});
        labelB.x = circleB.x + offsetX;
        labelB.y = circleB.y;
        labelB.anchor.set(0.5);
        this._graph.addChild(labelB);

        const titleLabelB = new PIXI.Text(this._graphLabelCopies[1].toUpperCase(), {
            fontSize: 24,
            fontFamily: "BBC Reith Sans",
            fontWeight: "bold",
            fill: colors[1]
        });
        titleLabelB.anchor.set(0.5);
        titleLabelB.x = circleB.x + offsetX * 1.25;
        titleLabelB.y = circleB.y - circleB.height * 0.5 - 20;
        this._graph.addChild(titleLabelB);

        const totalIntersect = this._question.values[2];
        const labelIntersect = new PIXI.Text(totalIntersect, {
            fontSize: 42,
            fontFamily: "BBC Reith Sans",
            fontWeight: "bold",
            fill: 0x696969
        });
        labelIntersect.x = (circleA.x + circleB.x) * 0.5;
        labelIntersect.y = circleB.y;
        labelIntersect.anchor.set(0.5);
        this._graph.addChild(labelIntersect);
    }

    /**
     * ven diagram with three sets
     */
    createVenTriple() {
        this._graph.image = new PIXI.mesh.NineSlicePlane(P3.assets.texture("answer_box_9slice"), 44, 88, 44, 88);
        this._graph.image.position.set(0, 60);
        this._graph.image.width = 520;
        this._graph.image.height = 310;
        this._graph.image.pivot.set(this._graph.image.width * 0.5, this._graph.image.height * 0.5);
        this._graph.addChild(this._graph.image);

        const circleTexture = P3.assets.texture("shape_2d_circle_1");

        const circleA = new PIXI.Sprite(circleTexture);
        circleA.anchor.set(0.5);
        const circleB = new PIXI.Sprite(circleTexture);
        circleB.anchor.set(0.5);
        const circleC = new PIXI.Sprite(circleTexture);
        circleC.anchor.set(0.5);

        circleA.x = -40;
        circleA.y = 100;

        circleB.x = 40;
        circleB.y = 100;

        circleC.x = 0;
        circleC.y = 20;

        this._graph.addChild(circleA, circleB, circleC);

        const offsetX = 50;
        const colors = [0xff0000, 0x0000ff, 0x0ff00f, 0xFF9A00, 0xFFE600, 0xEF00FF, 0x00F7FF, 0xFF9A00];

        //add in values
        const totalA = this._question.values[0];
        const labelA = new PIXI.Text(totalA, {fontSize: 42, fontFamily: "BBC Reith Sans", fontWeight: "bold", fill: colors[0]});
        labelA.x = circleA.x - offsetX;
        labelA.y = circleA.y;
        labelA.anchor.set(0.5);
        this._graph.addChild(labelA);

        const titleLabelA = new PIXI.Text(this._graphLabelCopies[0].toUpperCase(), {
            fontSize: 18,
            fontFamily: "BBC Reith Sans",
            fontWeight: "bold",
            fill: colors[0]
        });
        titleLabelA.anchor.set(0.5);
        titleLabelA.x = circleA.x - offsetX * 2.5;
        titleLabelA.y = circleA.y + circleA.height * 0.5 - 40;
        this._graph.addChild(titleLabelA);

        const totalB = this._question.values[1];
        const labelB = new PIXI.Text(totalB, {fontSize: 42, fontFamily: "BBC Reith Sans", fontWeight: "bold", fill: colors[1]});
        labelB.x = circleB.x + offsetX;
        labelB.y = circleB.y;
        labelB.anchor.set(0.5);
        this._graph.addChild(labelB);

        const titleLabelB = new PIXI.Text(this._graphLabelCopies[1].toUpperCase(), {
            fontSize: 18,
            fontFamily: "BBC Reith Sans",
            fontWeight: "bold",
            fill: colors[1]
        });
        titleLabelB.anchor.set(0.5);
        titleLabelB.x = circleB.x + offsetX * 2.5;
        titleLabelB.y = circleB.y + circleB.height * 0.5 - 40;
        this._graph.addChild(titleLabelB);

        const totalC = this._question.values[3];
        const labelC = new PIXI.Text(totalC, {fontSize: 42, fontFamily: "BBC Reith Sans", fontWeight: "bold", fill: colors[2]});
        labelC.x = (circleA.x + circleB.x) * 0.5;
        labelC.y = circleC.y - 40;
        labelC.anchor.set(0.5);
        this._graph.addChild(labelC);

        const titleLabelC = new PIXI.Text(this._graphLabelCopies[3].toUpperCase(), {
            fontSize: 18,
            fontFamily: "BBC Reith Sans",
            fontWeight: "bold",
            fill: colors[2]
        });
        titleLabelC.anchor.set(0.5);
        titleLabelC.x = circleB.x + offsetX * 2.5;
        titleLabelC.y = circleB.y - circleB.height * 0.5 - 40;
        this._graph.addChild(titleLabelC);

        const totalIntersectAB = this._question.values[2];
        const labelIntersectAB = new PIXI.Text(totalIntersectAB, {
            fontSize: 36,
            fontFamily: "BBC Reith Sans",
            fontWeight: "bold",
            fill: 0x696969
        });
        labelIntersectAB.x = (circleA.x + circleB.x) * 0.5;
        labelIntersectAB.y = (circleB.y + circleB.y) * 0.5 + 30;
        labelIntersectAB.anchor.set(0.5);
        this._graph.addChild(labelIntersectAB);

        const totalIntersectABC = this._question.values[4];
        const labelIntersectABC = new PIXI.Text(totalIntersectABC, {
            fontSize: 36,
            fontFamily: "BBC Reith Sans",
            fontWeight: "bold",
            fill: 0x0
        });
        labelIntersectABC.x = (circleA.x + circleB.x) * 0.5;
        labelIntersectABC.y = (circleA.y + circleB.y) * 0.5 - 30;
        labelIntersectABC.anchor.set(0.5);
        this._graph.addChild(labelIntersectABC);

        const totalIntersectAC = this._question.values[5];
        const labelIntersectAC = new PIXI.Text(totalIntersectAC, {
            fontSize: 36,
            fontFamily: "BBC Reith Sans",
            fontWeight: "bold",
            fill: 0x696969
        });
        labelIntersectAC.x = (circleA.x + circleC.x) * 0.5 - 30;
        labelIntersectAC.y = (circleA.y + circleC.y) * 0.5 - 10;
        labelIntersectAC.anchor.set(0.5);
        this._graph.addChild(labelIntersectAC);

        const totalIntersectBC = this._question.values[6];
        const labelIntersectBC = new PIXI.Text(totalIntersectBC, {
            fontSize: 36,
            fontFamily: "BBC Reith Sans",
            fontWeight: "bold",
            fill: 0x696969
        });
        labelIntersectBC.x = (circleC.x + circleB.x) * 0.5 + 30;
        labelIntersectBC.y = (circleC.y + circleB.y) * 0.5 - 10;
        labelIntersectBC.anchor.set(0.5);
        this._graph.addChild(labelIntersectBC);
    }

    generateWords(text, options, regex) {
        const words = {};
        options = options.slice();

        let result = text.match(regex);
        if (result) {
            for (let i = 0; i < result.length; ++i) {
                const t = result[i];
                const name = P3.utils.selectRandom(options);
                !words[t] && (words[t] = name);
                options.splice(options.indexOf(name), 1);
            }
        }
        return words;
    }

    generateValues(text, regex) {
        const values = {};

        //TODO - this should be set in the question rather than using type
        const useWords = this._question.type === QuestionModel.TYPE_MULTIPLICATION ?
            Math.random() < 0.5 : false;

        let result = text.match(regex);
        if (result) {
            for (let i = 0; i < result.length; ++i) {
                const t = result[i];
                const match = t.match(/[0-9]/);
                const index = match ? parseInt(match[0]) : 0;
                console.log(match);
                const value = this._question.values[index].value;
                if (!values[t]) {
                    values[t] = useWords ? converter.toWords(value) : value;
                }
            }
        }
        return values;
    }

    destroy() {
        if (this._generated) {
            for (let i = 0; i < this._generated.length; i++) {
                this._generated[i].destroy(true);
            }
        }
        super.destroy();
    }

    filterTemplate(x) {
        return x.part === this._question.part;
    }

    isCorrect() {
        if (this._question.templateType === QuestionModuleStats.TYPE_LOW ||
            this._question.templateType === QuestionModuleStats.TYPE_HIGH ||
            this._question.templateType === QuestionModuleStats.TYPE_EXACT) {
            return this._inputValue.toString() === this._question.answer.toString();
        }
        return parseInt(this._inputValue.value) === parseInt(this._question.answer.value);
    }

    get graph() {
        return this._graph;
    }
}